import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import toaster from 'react-hot-toast';
import { submitTwilioCustomerProfile } from 'api/admin/businesses/twilioIntegration';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';
import { TwilioCustomerProfileHttpResponse } from 'types/twilio/twilioCustomerProfile';

export const useSubmitTwilioCustomerProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<TwilioCustomerProfileHttpResponse>,
    AxiosError<{ error: string }>,
    {
      businessId: number;
      customerProfileId: string;
    }
  >({
    mutationFn: async ({ businessId, customerProfileId }) => {
      return submitTwilioCustomerProfile(businessId, customerProfileId);
    },
    onSuccess: async ({ data }, { businessId }) => {
      queryClient.setQueryData<TwilioCustomerProfileHttpResponse>(
        [TwilioQueryKeys.CUSTOMER_PROFILE, businessId],
        data,
      );

      toaster('Customer profile has been submitted', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(
        error?.response?.data?.error ?? 'An error occurred while submitting customer profile',
        {
          icon: '❌',
        },
      );
    },
  });
};
